import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import RightDrawerDesktop from "../../../../components/WMS/Desktop/RightDrawerDesktop";
import Toggle from "../../../../components/WMS/Mobile/Toggle/Toggle";
import {FormattedMessage} from "react-intl";
import {Card, CardContent, Grid} from "@mui/material";
import ToggleNavigation from "../../../../components/WMS/Mobile/Toggle/ToggleNavigation";
import {greyishBlue500, red500} from "../../../../assets/jss/main";
import MobileItem from "../../../../components/WMS/Mobile/MobileItem";
import LineItemOptionList from "../../../../components/WMS/Mobile/WmsItemList/components/LineItemOptionList";
import ThumbnailAndNotification from "../../../../components/WMS/Mobile/ThumbnailAndNotification";
import ValidButtons from "./ValidButtons";
import {LineItemStatus} from "../../../../utils/LineItemStatus";
import Badge from "../../../../components/Badge";
import store from "../../../../store";
import {UserAgentUtils} from "../../../../utils/useragent";
import {getShipmentById} from "../../../../api/shipment/getWithId";
import {returningRetailerItem} from "../../../../api/lineItem/returning-retailer";
import {confirmReturnItem} from "../../../../api/lineItem/confirm-return";
import CancellationReasonDrawer
    from "../../clickAndCollect/list/components/TakeoutShipmentPopup/components/CancellationReasonDrawer";
import {cancelItem} from "../../../../api/lineItem/cancelItem";
import {LineItemTransitions} from "../../../../utils/lineItemTransitions";
import {list as cancellationReasonList} from "../../../../api/cancellationReason/list";

ValidProductDrawer.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    shipmentId: PropTypes.string.isRequired,
    isRunner: PropTypes.bool.isRequired,
    handleFinishReturn: PropTypes.func.isRequired
};

function ValidProductDrawer({open, handleClose, shipmentId, isRunner, handleFinishReturn}) {
    const [shipment, setShipment] = useState({})
    const [isMobile, setIsMobile] = useState(UserAgentUtils.isMobile())
    const [isValid, setIsValid] = useState(0)
    const [locale, setLocale] = useState(store.getState().currentOrganization?.retrieved?.defaultLocale)
    const [toBeCancelledItem, setToBeCancelledItem] = useState()
    const [filteredCancellationReasons, setFilteredCancellationReasons] = useState([])
    const [openCancellationReasonDrawer, setOpenCancellationReasonDrawer] = useState(false)
    const [cancellationReasons, setCancellationReasons] = useState([])

    const defaultPicture = "https://marketplace-wishibam-dev.s3.eu-west-3.amazonaws.com/medias/aefd931d-7132-443f-bc29-e73cd7d63e9c_BHV/62417341319fd7c7c23665809131f084J2BO_tfHb-RUb0ZsriI3l6v5iMJgqYDC-Qcdw6mw3AbF6IptaPbXVwBJZ3gdRLEKBz9sjHSSCiPsSIKU67NBmg.png"

    const getValidLineItem = () => {
        let count = 0
        if (0 < Object.keys(shipment).length) {
            const lineItems = shipment?.lineItems ?? []

            lineItems.forEach(item => {
                if (isRunner) {
                    if (LineItemStatus.RETURNING_RETAILER === item.status || (LineItemStatus.CONFIRMED === item.status && item.cancellationReason)) {
                        count++
                    }
                } else {
                    if (LineItemStatus.RETURNED === item.status || (LineItemStatus.CONFIRMED === item.status && item.cancellationReason)) {
                        count++
                    }
                }
            })
        }

        return count;
    }

    const getNotValidLineItem = () => {
        let count = 0

        if (0 < Object.keys(shipment).length) {
            const lineItems = shipment?.lineItems ?? []

            lineItems.forEach(item => {
                if (isRunner) {
                    if (LineItemStatus.RETURNING_RUNNER === item.status) {
                        count++
                    }
                } else {
                    if (LineItemStatus.RETURNING_RETAILER === item.status) {
                        count++
                    }
                }
            })
        }
        return count;
    }

    const getCancellationReason = (item, isReturnCancelled) => {
        if (isReturnCancelled) {
            return <Badge color={"error"} rounded>{item.cancellationReason?.translations[locale].name}</Badge>
        } else if (item.cancellationReason) {
            return <Badge rounded>{item.cancellationReason?.translations[locale].name}</Badge>
        }
    }

    const handleCloseCancellationReasonDrawer = () => {
        setOpenCancellationReasonDrawer(false);
    }

    const handleSelectedCancellationReason = (reason) => {
        cancelItem(toBeCancelledItem, reason).then(response => {
            handleGetShipment()
        })
    }

    const handleGetShipment = () => {
        if (typeof shipmentId === "string" && 0 < shipmentId.length) {
            getShipmentById(shipmentId).then(response => {
                setShipment(response)
            })
        }
    }

    function filterCancellationReasonsByItemStatus(item) {
        // cancel_returning_runner reason for item status returning-runner
        // cancel_returning_retailer reason for item status returning-retailer
        return cancellationReasons.filter(reason => reason.status === item.status);
    }

    function getCancellationReasons() {
        const params = [
            `transition[]=${LineItemTransitions.CANCEL_RETURNING_RUNNER}`,
            `transition[]=${LineItemTransitions.CANCEL_RETURNING_RETAILER}`,
            'itemAllowed=true',
            'enabled=true'
        ];

        cancellationReasonList(params.join('&')).then(response => {
            setCancellationReasons(response);
        })
    }


    const handleIsValid = (isValid, item) => {
        if(!isValid) {
            setToBeCancelledItem(item)

            setFilteredCancellationReasons(filterCancellationReasonsByItemStatus(item));

            setOpenCancellationReasonDrawer(true)
        } else {
            if (LineItemStatus.RETURNING_RUNNER === item.status) {
                returningRetailerItem(item).then(response => {
                    handleGetShipment()
                })
            }

            if (LineItemStatus.RETURNING_RETAILER === item.status) {
                confirmReturnItem(item).then(response => {
                    handleGetShipment()
                })
            }
        }
    }

    useEffect(() => {
        handleGetShipment()
        getCancellationReasons()
    }, [shipmentId]);

    useEffect(() => {
        const lineItems = shipment?.lineItems

        if (Array.isArray(lineItems) && 0 < lineItems.length) {
            if (isRunner && lineItems.every(item => LineItemStatus.CONFIRMED === item.status || LineItemStatus.RETURNING_RETAILER === item.status)) {
                handleFinishReturn()
            }

            if (!isRunner && lineItems.every(item => LineItemStatus.CONFIRMED === item.status || LineItemStatus.RETURNED === item.status)) {
                handleFinishReturn()
            }
        }
    }, [shipment]);

    return (
        <RightDrawerDesktop
            open={open}
            onClose={handleClose}
            disablePortal
            openMaxWidth ={isMobile}
            customContentPadding={"8px"}
            title={
                <span style={{
                    fontSize: "16px",
                    fontWeight: 600
                }}>
                    <FormattedMessage id={"wms.receptionList.validation.drawer.title"}/>
                </span>
            }
            subtitle={
                <span style={{
                    color: greyishBlue500,
                    fontWeight: 400,
                    fontSize: "14px"
                }}>
                <FormattedMessage id={"wms.receptionList.validation.drawer.subtitle"}/>
                </span>
            }
        >
            <Grid container direction={'column'} gap={"16px"}>
                <Card>
                    <CardContent>
                        <div style={{
                            margin: "auto",
                            width: "fit-content"
                        }}>
                            {openCancellationReasonDrawer && filteredCancellationReasons &&(
                                <CancellationReasonDrawer
                                    isOpen={openCancellationReasonDrawer}
                                    handleClose={handleCloseCancellationReasonDrawer}
                                    cancellationReasons={filteredCancellationReasons}
                                    setSelectedReason={handleSelectedCancellationReason}
                                />
                            )}

                            <ToggleNavigation
                                value={isValid}
                                onChange={(value) => {
                                    setIsValid(value)
                                }}
                            >
                                <Toggle
                                    count={getNotValidLineItem()}
                                    label={(<FormattedMessage id={"wms.receptionList.validation.drawer.waitingValidation"} />)}
                                    large
                                />
                                <Toggle
                                    count={getValidLineItem()}
                                    label={(<FormattedMessage id={"wms.receptionList.validation.drawer.valid"} />)}
                                    large
                                />
                            </ToggleNavigation>
                        </div>

                        {0 < Object.keys(shipment).length && !isValid && shipment?.lineItems.map((item, index) => {
                            if ((isRunner && LineItemStatus.RETURNING_RUNNER === item.status) || (!isRunner && LineItemStatus.RETURNING_RETAILER === item.status)) {
                                return (
                                    <MobileItem key={index}>
                                        <MobileItem.LeftSide
                                            title={<>{item.brand} <span
                                                style={{fontWeight: "normal"}}> • {item.name}</span></>}
                                            subtitle={<LineItemOptionList options={item.options}/>}
                                            underTitle={getCancellationReason(item, false)}
                                        >
                                            <ThumbnailAndNotification
                                                link={item.pictures?.[0] || defaultPicture}
                                                alt={item.name}
                                            />
                                        </MobileItem.LeftSide>
                                        <MobileItem.RightSide>
                                            <ValidButtons handleIsValid={handleIsValid} item={item}/>
                                        </MobileItem.RightSide>
                                    </MobileItem>
                                )
                            }
                        })}

                        <Grid container direction={'column'} gap={"16px"}>
                            <Grid container direction={"column"}>
                                {0 < Object.keys(shipment).length && isValid ? (shipment?.lineItems.map((item, index) => (
                                    <>
                                        {((isRunner && LineItemStatus.RETURNING_RETAILER === item.status) || (!isRunner && LineItemStatus.RETURNED === item.status)) && (
                                            <MobileItem key={index}>
                                                <MobileItem.LeftSide
                                                    title={<>{item.brand} <span
                                                        style={{fontWeight: "normal"}}> • {item.name}</span></>}
                                                    subtitle={<LineItemOptionList options={item.options}/>}
                                                    underTitle={getCancellationReason(item, false)}
                                                >
                                                    <ThumbnailAndNotification
                                                        link={item.pictures?.[0] || defaultPicture}
                                                        alt={item.name}
                                                        validated
                                                    />
                                                </MobileItem.LeftSide>
                                            </MobileItem>
                                        )}
                                    </>
                                ))) : <></>}
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>

                {isValid ? (
                    <Card>
                        <CardContent>
                            <Grid container direction={"column"}>

                                <span style={{color: red500, fontWeight: "bold", marginBottom:"8px"}}><FormattedMessage id={"wms.receptionList.cancelledProductList"}/></span>

                                {0 < Object.keys(shipment).length && shipment.lineItems.map((item, index) => {
                                        if (LineItemStatus.CONFIRMED === item.status && item.cancellationReason) {
                                            return (
                                                <MobileItem key={index}>
                                                    <MobileItem.LeftSide
                                                        title={<>{item.brand} <span
                                                            style={{fontWeight: "normal"}}> • {item.name}</span></>}
                                                        subtitle={<LineItemOptionList options={item.options}/>}
                                                        underTitle={getCancellationReason(item, true)}
                                                    >
                                                        <ThumbnailAndNotification
                                                            link={item.pictures?.[0] || defaultPicture}
                                                            alt={item.name}
                                                            unavailable
                                                        />
                                                    </MobileItem.LeftSide>
                                                </MobileItem>
                                            )
                                        }
                                    }
                                )}
                            </Grid>
                        </CardContent>
                    </Card>
                ) : <></>}
            </Grid>
        </RightDrawerDesktop>
    );
}

export default ValidProductDrawer;
